<div class="container">

  <div class="row">
    <div class="col-12 col-md-4">
      <div class="card">

        <div class="card-header">

          <app-brand-header></app-brand-header>

        </div>

        <form (ngSubmit)="onSubmit()" [formGroup]="form">

          <div class="card-body">

            @for (formField of formFields; track formField) {
              <div class="mb-2">
                <app-form-field [formField]="formField" [form]="form" (emitCheckedEvent)="changeMemberSelection($event)"></app-form-field>
              </div>
            }

            <div class="row">
              <div class="col-6">
                <button type="submit" icon="fa fa-check" class="btn btn-primary" [disabled]="!form.valid">Submit</button>
                <button type="button" icon="fa fa-close" class="btn btn-danger" (click)="onClose()" label="Close">Cancel</button>
              </div>
            </div>

            @if (isSuccessMessageShown) {
              <div class="alert alert-success" role="alert">{{successMessage}}</div>
            }
            @if (isErrorMessageShown) {
              <div class="alert alert-danger" role="alert">{{errorMessage}}</div>
            }

          </div>

          <div class="card-footer">

            <app-brand-footer></app-brand-footer>

          </div>

        </form>

      </div>
    </div>
  </div>

</div>

